import { render, staticRenderFns } from "./IconDetail.vue?vue&type=template&id=bea5bc9e&"
import script from "./IconDetail.vue?vue&type=script&lang=ts&"
export * from "./IconDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports